import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
export const PICKUP_CONFIRM_KEY = 'ride.pickupConfirm';
export const PICKUP_CONFIRM_BOUNDS = {
    editRadiusMeters: { min: 50, max: 2_000 },
    requoteToleranceMeters: { min: 0, max: 200 },
};
export const DEFAULT_PICKUP_CONFIRM = { editRadiusMeters: 300, requoteToleranceMeters: 25 };
export const STRICT_PICKUP_CONFIRM = { editRadiusMeters: PICKUP_CONFIRM_BOUNDS.editRadiusMeters.min, requoteToleranceMeters: 0 };
export const PICKUP_CONFIRM_REASON_CODES = ['PICKUP_CONFIRM_GOVERNED', 'PICKUP_CONFIRM_DEFAULT', 'PICKUP_CONFIRM_INVALID'];
const MEMBERS = ['editRadiusMeters', 'requoteToleranceMeters'];
export function pickupConfirmIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, MEMBERS))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = PICKUP_CONFIRM_BOUNDS;
    if (!intWithin(v.editRadiusMeters, b.editRadiusMeters.min, b.editRadiusMeters.max))
        return 'INVALID_EDIT_RADIUS_METERS';
    if (!intWithin(v.requoteToleranceMeters, b.requoteToleranceMeters.min, b.requoteToleranceMeters.max))
        return 'INVALID_REQUOTE_TOLERANCE_METERS';
    if (v.requoteToleranceMeters > v.editRadiusMeters)
        return 'REQUOTE_TOLERANCE_ABOVE_EDIT_RADIUS';
    return undefined;
}
export const PICKUP_CONFIRM_SPEC = {
    key: PICKUP_CONFIRM_KEY,
    issue: pickupConfirmIssue,
    copy: (v) => ({ editRadiusMeters: v.editRadiusMeters, requoteToleranceMeters: v.requoteToleranceMeters }),
    defaultValue: DEFAULT_PICKUP_CONFIRM,
    strictValue: STRICT_PICKUP_CONFIRM,
    reasonPrefix: 'PICKUP_CONFIRM',
};
export function pickupConfirmSetting(input) {
    return marketRuleSetting(PICKUP_CONFIRM_SPEC, input);
}
export function resolvePickupConfirm(settings, marketId, at, regionCode) {
    return resolveMarketRule(PICKUP_CONFIRM_SPEC, settings, marketId, at, regionCode);
}
export function pickupConfirmWire(decision) {
    return { editRadiusMeters: decision.value.editRadiusMeters, requoteToleranceMeters: decision.value.requoteToleranceMeters, policyVersion: decision.policyVersion };
}
//# sourceMappingURL=ride-pickup-confirm-policy.js.map